import Image from 'next/image';
import { cn } from '@lib/utils';

export default function MobileSectionEclipse({
  half,
  className,
}: {
  half: 'upper' | 'lower';
  className?: string;
}) {
  const isUpper = half === 'upper';

  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-x-0 overflow-hidden xl:hidden',
        'aspect-[390/120]',
        isUpper ? 'bottom-0' : 'top-0',
        className,
      )}
    >
      <Image
        src={
          isUpper
            ? '/images/main/reanalysis/eclipse-desktop-upper.png'
            : '/images/main/reanalysis/eclipse-desktop-lower.png'
        }
        alt=""
        width={4390}
        height={560}
        sizes="115vw"
        className={cn(
          'absolute left-1/2 h-auto w-[240%] max-w-none -translate-x-1/2',
          isUpper ? 'top-[2px]' : 'top-0',
        )}
      />
    </div>
  );
}
